<ch-loader [loading]="isInitialLoading"></ch-loader>
<div [ngStyle]="{ display: isInitialLoading ? 'none' : 'block' }">
  <ch-breadcrumb [parts]="breadcrumbs" (goTo)="cancel()"></ch-breadcrumb>
  <form (ngSubmit)="save(form)" #form="ngForm">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 col-md-12">
          <div class="card mb-4">
            <div class="card-header">Form</div>
            <div class="card-body">
              <div class="form-group">
                <label for="ab-tests-edit-name">Name</label>
                <input type="text" [(ngModel)]="abTest.name" name="name" #name="ngModel" class="form-control"
                  id="ab-tests-edit-name" required [readonly]="loading" />
                <small class="text-danger" *ngIf="(name.touched || name.dirty) && !name.value">
                  Name should not be blank.
                </small>
              </div>
              <div class="form-group">
                <label for="ab-test-description">Description</label>
                <div>
                  <textarea type="text" name="abTestDescription" class="form-control" id="ab-test-description"
                    [(ngModel)]="abTest.description" #abTestDescription="ngModel" required
                    [readonly]="loading"></textarea>
                  <small class="text-danger"
                    *ngIf="(abTestDescription.touched || abTestDescription.dirty) && !abTestDescription.value">
                    Description should not be blank.
                  </small>
                </div>
              </div>
              <div class="form-group">
                <label for="ab-test-split">
                  Split
                  <small class="text-muted">
                    (this is the percentage of users that will see the original variant)
                  </small>
                </label>
                <input type="number" name="abTestSplit" class="form-control" id="ab-test-split"
                  [(ngModel)]="abTest.split" #abTestSplit="ngModel" min="0" max="100" required [readonly]="loading" />
                <small class="text-danger" *ngIf="(abTestSplit.touched || abTestSplit.dirty) && !abTestSplit.valid">
                  Split is required.
                </small>
                <small class="text-danger"
                  *ngIf="(abTestSplit.touched || abTestSplit.dirty) && (abTestSplit.value < 0 || abTestSplit.value > 100)">
                  Split should be between 0 and 100.
                </small>
              </div>
              <div class="form-group">
                <div class="custom-control custom-checkbox">
                  <input id="ab-test-is-active" #abTestIsActive type="checkbox" name="abTestIsActive"
                    [(ngModel)]="abTest.isActive" class="custom-control-input" />
                  <label class="custom-control-label" for="ab-test-is-active">Is Active?</label>
                </div>
              </div>
              <div class="form-group">
                <div class="custom-control custom-checkbox">
                  <input id="ab-test-use-unauth-id" #abTestIsActive type="checkbox" name="abTestUseUnauthId"
                    [(ngModel)]="abTest.useUnauthId" class="custom-control-input" />
                  <label class="custom-control-label" for="ab-test-use-unauth-id">Use Unauth ID?</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="ab-test-image-a">Variant A image (Max size: 4MB)</label>
                    <ch-image-upload (onChange)="imageAChanged($event)"
                      [resourceId]="abTest.imageAId"></ch-image-upload>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="ab-test-image-a">Variant B image (Max size: 4MB)</label>
                    <ch-image-upload (onChange)="imageBChanged($event)"
                      [resourceId]="abTest.imageBId"></ch-image-upload>
                  </div>
                </div>
              </div>
              <div style="margin-top: 40px">
                <span class="btn-right">
                  <button id='abTestsEditCancel' class="btn btn-secondary" type='button' (click)="cancel()"
                    [disabled]="loading">
                    Cancel
                  </button>
                  <button *ngIf='paramId !== null' id='abTestsEditSave' class="btn btn-danger" type="button"
                    (click)="delete()" [disabled]="loading">
                    Delete
                  </button>
                  <button id='abTestsEditSave' type="submit" class="btn btn-primary"
                    [disabled]="loading || !form.valid">
                    Save
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/ab-tests/ab-tests-edit/ab-tests-edit.component.html